export enum EInsightsIASeverity {
  Critical = 2,
  Warning = 1,
  Info = 0
}
